import { Component, OnInit } from '@angular/core';
import { Apiservice } from '../../../../services/ApiService';
import { ApiVenue, VenueListExtended } from '../../../../models/venue-admin.model';

interface VenueRow extends ApiVenue {
  id: string;
}

@Component({
  selector: 'app-venues-tab',
  templateUrl: './venues-tab.component.html',
  standalone: false,
  styleUrls: ['./venues-tab.component.scss']
})
export class VenuesTabComponent implements OnInit {
  loading = false;
  loadError = '';
  record: VenueListExtended | null = null;
  rows: VenueRow[] = [];
  filterText = '';
  isAdding = false;

  constructor(private apiservice: Apiservice) {}

  ngOnInit(): void {
    this.loadVenueAdmin();
  }

  loadVenueAdmin() {
    this.loading = true;
    this.loadError = '';
    this.apiservice.getVenueAdmin().subscribe({
      next: (result) => {
        this.record = result;
        this.rows = this.buildRows(result);
        this.loading = false;
      },
      error: (err) => {
        this.loadError = err?.status === 401
          ? 'You do not have permission to view venue admin.'
          : 'Failed to load venues. Please try again.';
        this.loading = false;
      }
    });
  }

  private buildRows(record: VenueListExtended): VenueRow[] {
    const venues = record?.venues ?? {};
    return Object.keys(venues)
      .sort((a, b) => (venues[a].name || a).localeCompare(venues[b].name || b))
      .map((id) => ({
        id,
        ...venues[id]
      }));
  }

  openAddVenue() {
    this.isAdding = true;
  }

  onVenueCancelled() {
    this.isAdding = false;
  }

  onVenueSaved() {
    this.isAdding = false;
    this.loadVenueAdmin();
  }

  get filteredRows(): VenueRow[] {
    const q = this.filterText.trim().toLowerCase();
    if (!q) { return this.rows; }
    return this.rows.filter((r) =>
      r.id.toLowerCase().includes(q) ||
      (r.name || '').toLowerCase().includes(q) ||
      (r.timezone || '').toLowerCase().includes(q) ||
      (r.Continent || '').toLowerCase().includes(q) ||
      (r.City || '').toLowerCase().includes(q) ||
      (r.parents || []).some((p) => p.toLowerCase().includes(q))
    );
  }
}
